module.exports = __webpack_public_path__ + "img/scene1-4.ff0b6fdc.jpg";